import axiosClient from './axiosClient';

const productsApi = {
  // Catalogo publico / admin
  getProducts: (params) => axiosClient.get('/products', { params }),
  getProduct: (id) => axiosClient.get(`/products/${id}`),
  createProduct: (data) => axiosClient.post('/products', data),
  updateProduct: (id, data) => axiosClient.put(`/products/${id}`, data),
  deleteProduct: (id) => axiosClient.delete(`/products/${id}`),

  // Categorias
  getCategories: (params) => axiosClient.get('/categories', { params }),
  createCategory: (data) => axiosClient.post('/categories', data),
  updateCategory: (id, data) => axiosClient.put(`/categories/${id}`, data),
  deleteCategory: (id) => axiosClient.delete(`/categories/${id}`),

  // Marcas
  getBrands: (params) => axiosClient.get('/brands', { params }),
  createBrand: (data) => axiosClient.post('/brands', data),
  updateBrand: (id, data) => axiosClient.put(`/brands/${id}`, data),
  deleteBrand: (id) => axiosClient.delete(`/brands/${id}`),

  // Atributos de producto (product_attributes)
  getProductAttributes: (productId) => axiosClient.get(`/products/${productId}/attributes`),
  saveProductAttributes: (productId, data) => axiosClient.put(`/products/${productId}/attributes`, data),

  // Galeria de imagenes del producto (la primera subida queda como destacada)
  uploadProductImage: (productId, file) => {
    const formData = new FormData();
    formData.append('image', file);
    return axiosClient.post(`/products/${productId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteProductImage: (productId, imageId) => axiosClient.delete(`/products/${productId}/images/${imageId}`),
  setPrimaryProductImage: (productId, imageId) => axiosClient.post(`/products/${productId}/images/${imageId}/primary`),

  // Unidades fisicas del producto (numeros de serie): se asignan solas a la venta, no se
  // eligen a mano (ver OrderController::assignSerials en el backend).
  getProductSerials: (productId) => axiosClient.get(`/products/${productId}/serials`),
  addProductSerial: (productId, serie) => axiosClient.post(`/products/${productId}/serials`, { serie }),
  deleteProductSerial: (productId, serialId) => axiosClient.delete(`/products/${productId}/serials/${serialId}`),

  // Lectura de codigo de barras
  getProductByBarcode: (barcode) => axiosClient.get(`/products/barcode/${barcode}`),

  // Dashboard: utilidad por componentes vendidos + valor de inventario (solo administrador)
  getProductStats: (granularity) => axiosClient.get('/products/stats', { params: { granularity } }),
};

export default productsApi;
